// Global report filters (top bar): period, compare-to basis, channel families.
// UI state only; persisted per browser.
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CompareId, PeriodId } from '../api/types/hd';

export const PERIODS: { id: PeriodId; label: string }[] = [
  { id: 'l90', label: 'Last 90 days' },
  { id: 'l30', label: 'Last 30 days' },
  { id: 'jul', label: 'Jul 2026' },
  { id: 'aug', label: 'Aug 2026' },
  { id: 'sep', label: 'Sep 2026 (1–23)' },
];
export const COMPARES: { id: CompareId; label: string }[] = [
  { id: 'plan', label: 'Plan' },
  { id: 'priorPeriod', label: 'Prior period' },
  { id: 'reforecast', label: 'Reforecast' },
  { id: 'stretch', label: 'Stretch' },
  { id: 'downside', label: 'Downside' },
];

export interface FilterState {
  period: PeriodId;
  compare: CompareId;
  /** Channel family ids; empty = all channels. */
  channels: string[];
  setPeriod: (p: PeriodId) => void;
  setCompare: (c: CompareId) => void;
  setChannels: (ids: string[]) => void;
}

export const useFilters = create<FilterState>()(
  persist(
    (set) => ({
      period: 'l90',
      compare: 'plan',
      channels: [],
      setPeriod: (period) => set({ period }),
      setCompare: (compare) => set({ compare }),
      setChannels: (channels) => set({ channels }),
    }),
    { name: 'hx.filters', version: 1 },
  ),
);

export const periodLabel = (id: PeriodId) => PERIODS.find((p) => p.id === id)?.label ?? id;
export const compareLabel = (id: CompareId) => COMPARES.find((c) => c.id === id)?.label ?? id;
/** True when the family passes the channel filter. */
export const familyOn = (channels: readonly string[], familyId: string | undefined) =>
  !channels.length || (familyId !== undefined && channels.includes(familyId));
